import { render, staticRenderFns } from "./TreatmentRequestListMobile.vue?vue&type=template&id=592e544b&scoped=true&"
import script from "./TreatmentRequestListMobile.vue?vue&type=script&lang=ts&"
export * from "./TreatmentRequestListMobile.vue?vue&type=script&lang=ts&"
import style0 from "./TreatmentRequestListMobile.vue?vue&type=style&index=0&id=592e544b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e544b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VIcon,VTextField})
